var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "#FFFFFF",
    className: "css-1b4920d e1k0l6qr0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.2,
    cx: 14,
    cy: 14,
    r: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.64 7C15.34 7 14 8.9 14 8.9S12.67 7 10.36 7A4.27 4.27 0 0 0 6 11.16c0 4.04 4.95 7.9 7.2 9.58a1.36 1.36 0 0 0 1.6 0c2.25-1.68 7.2-5.54 7.2-9.57C22 8.86 20.05 7 17.64 7",
    fill: "#F51315"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteActive);
export default __webpack_public_path__ + "static/media/favoriteActive.65a998dd654c818b9ac395cbef4e88f8.svg";
export { ForwardRef as ReactComponent };